import { getInitialValues, requiredMessage } from "@/lib/utils";
import AuthService from "@/services/api/auth/auth";
import React, { useEffect, useMemo, useState, createContext, useContext } from 'react'
import { useForm } from "react-hook-form";
import toast from "@/lib/toast";
import MapView from "@/components/Map/MapView";
import { useDrawer } from '@/components/Drawer/context/DrawerContext';


import Modal from '@/components/Modal/Modal';
import { Button, Tooltip, Typography } from '@mui/material';
import { VALIDATION_ERROR_MESSAGES } from "@/lib/constants";
import formRenderer from "@/lib/formRenderer";
import { emailRegex, mobileRegex } from "@/lib/regex";
import Table from '@/components/Table/Table'

import { Tabs, Tab, Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";



interface RetilerRow {
    RetailerShopName: string;
    PersonName: string;
    Designation: string;
    Email: string;
    PhoneNumber: string;
    Action: string;

}

const ORDER_TABS = [
    { key: "AllOrders", label: "All Orders" },
    { key: "Requested", label: "Requested" },
    { key: "Approved", label: "Approved" },
    { key: "Delivered", label: "Delivered" },
    { key: "Declined", label: "Declined" },
];

const OrderListItem: React.FC = () => {
    // const { setDistributorId } = useDistributor();
    const { openDrawer, closeDrawer } = useDrawer();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [loading, setLoading] = useState(true);
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [Localities, setLocalities] = useState<any[]>([]);
    const [attendanceData, setAttendanceData] = useState<RetilerRow[]>([]);
    const [mapModalOpen, setMapModalOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState("");
    const [mapLocation, setMapLocation] = useState({ lat: 18.96905, lng: 72.82118 });
    const [countrySearch, setCountrySearch] = useState("");
    const [stateSearch, setStateSearch] = useState("");
    const [citySearch, setCitySearch] = useState("");
    const [LocalitySearch, setLocalitySearch] = useState("");
    const [phoneNumber, setPhoneNumber] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const handleCloseModal = () => setModalOpen(false);
    const [countries, setCountries] = useState<any[]>([]);
    const [searchText, setSearchText] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [shareLink, setShareLink] = useState("");
    const [loadingLink, setLoadingLink] = useState(false);
    const [copied, setCopied] = useState(false);
    const [totalRecords, setTotalRecords] = useState<number | null>(null);
    const [activeTab, setActiveTab] = useState("AllOrders");
    const  navigate=useNavigate();
    // const location=useLocation();
    // const orderID=location.state?.orderID;
    // const { orderID } = useParams();
    const location = useLocation();
const orderID = location.state?.orderID;
    
    const AllOrders = [
        { name: "SKU Code", selector: (row: any) => row.orderID },
        // { name: "Order Date", selector: (row: any) => dayjs(row.orderDate).format('DD/MM/YYYY') },
        { name: "Product Name", selector: (row: any) => row.companyName },
        // { name: "List Items", selector: (row: any) => row.listItems },
        { name: "Product Description", selector: (row: any) => row.totalQuantity },
        { name: "Quantity", selector: (row: any) => row.retailerName },
       
      
       
    ];


    
    const columns = useMemo(
        () => [
            // {name:"id",selector:(row:any)=>row.id},
            { name: "SKU Code", selector: (row: any) => row.orderID },
            // { name: "Order Date", selector: (row: any) => dayjs(row.orderDate).format('DD/MM/YYYY') },
            { name: "Product Name", selector: (row: any) => row.companyName },
            // { name: "List Items", selector: (row: any) => row.listItems },
            { name: "Product Description", selector: (row: any) => row.itemQty },
            // { name: "Retailer", selector: (row: any) => row.retailerName },
            { name: "Quantity", selector: (row: any) => row.retailerEmail },
            // { name: "Est. Delivery Date", selector: (row: any) => row.expectedDeliveryDate },
           
           
        








        ], []
    )

    const handleOpenModal = () => {
        reset(getInitialValues(formConfig));
        setSelectedRow(null);
        setModalOpen(true);
    };

    

    const DeleteRetailerRow = (row: any) => {
        setSelectedRow(row);
        setDeleteModalOpen(true);
    }

    const formConfig = useMemo(
        () => ({
            companyName: {
                defaultValue: "",
                validations: { required: requiredMessage("Retailer Shop Name") },
                controlType: "input",
                placeholder: "Enter Retailer Shop Name",
                label: "Retailer Shop Name",
                isRequired: true,
                // className: styles.fullRow
            },
            name: {
                defaultValue: "",
                validations: { required: requiredMessage("Person Name") },
                controlType: "input",
                label: "Person Name ",
                placeholder: "Enter Person Name",
                isRequired: true,
            },
            designation: {
                defaultValue: "",
                validations: { required: requiredMessage("Designation") },
                controlType: "input",
                label: "Designation Name",
                placeholder: "Enter Designation",
                isRequired: true,
            },
            emailId: {
                defaultValue: "",
                validations: {
                    required: requiredMessage("Email ID"),
                    pattern: {
                        value: emailRegex,
                        message: VALIDATION_ERROR_MESSAGES.EMAIL_FORMAT,
                    },
                },
                controlType: "input",
                label: "Enter Email ID",
                placeholder: "Enter Email ID",
                isRequired: true,
            },
            mobileNumber: {
                defaultValue: "",
                validations: {
                    required: requiredMessage("Retailer Number"),
                    pattern: {
                        value: mobileRegex,
                        message: VALIDATION_ERROR_MESSAGES.ONLY_NUMBERS,
                    },
                },
                controlType: "input",
                label: "Mobile Number",
                placeholder: "Enter Mobile ID",
                isRequired: true,
            },
            contactEmail: {
                defaultValue: "",
                // validations: {
                //     required: requiredMessage("Email ID"),
                //     pattern: {
                //         value: emailRegex,
                //         message: VALIDATION_ERROR_MESSAGES.EMAIL_FORMAT,
                //     },
                // },
                controlType: "input",
                label: "Alternate Email ID",
                placeholder: "Enter Email ID",
                // isRequired: true,
            },
            contactNo: {
                defaultValue: "",
                // validations: {
                //     required: requiredMessage("Mobile Number"),
                //     pattern: {
                //         value: mobileRegex,
                //         message: VALIDATION_ERROR_MESSAGES.ONLY_NUMBERS,
                //     },
                // },
                controlType: "input",
                label: "Alternate Mobile Number",
                placeholder: "Enter Mobile Number",
                // isRequired: true,
            },

            address: {
                defaultValue: "",
                // validations: { required: requiredMessage("Address") },
                controlType: "input",
                label: "Enter Address",
                // isRequired: true,
                onFieldClick: () => setMapModalOpen(true),
                // className: styles.fullRow
            },

            latitude: {
                defaultValue: "",
                controlType: "hidden",
                label: "Latitude",
            },
            longitude: {
                defaultValue: "",
                controlType: "hidden",
                label: "Longitude",
            },
            countryId: {
                defaultValue: null,
                validations: {
                    required: {
                        value: true,
                        message: requiredMessage("Country"),
                    },
                },
                options: countries,
                controlType: "select",
                label: "Country",
                isRequired: true,
                isMulti: false,
                isControlled: true,
                onInputChange: (val: string) => setCountrySearch(val),
                noOptionsMessage: () => (countrySearch ? "No results found" : "Search Country..."),
            },
            stateId: {
                defaultValue: null,
                validations: {
                    required: {
                        value: true,
                        message: requiredMessage("State"),
                    },
                },
                options: states,
                controlType: "select",
                label: "State",
                isRequired: true,
                isMulti: false,
                isControlled: true,
                onInputChange: (val: string) => setStateSearch(val),
                noOptionsMessage: () => (stateSearch ? "No results found" : "Search State..."),
            },
            cityId: {
                defaultValue: null,
                validations: {
                    required: {
                        value: true,
                        message: requiredMessage("City"),
                    },
                },
                options: cities, // <-- Cities, dynamically set
                controlType: "select",
                label: "City",
                isRequired: true,
                isMulti: false,
                isControlled: true,
                onInputChange: (val: string) => setCitySearch(val),
                noOptionsMessage: () => (citySearch ? "No results found" : "Search City...")
            },
            // Locality: {
            //   defaultValue: null,

            //   options: Localities,
            //   controlType: "select",
            //   label: "Locality",

            //   isMulti: false,
            //   isControlled: true,
            //   onInputChange: (val: string) => setLocalitySearch(val),
            //  noOptionsMessage: () => (citySearch ? "No results found" : "Search Locality...")
            // },
            pincode: {
                defaultValue: "",
                validations: { required: requiredMessage("Pincode") },
                controlType: "input",
                label: "Pincode",
                isRequired: true,
            },





        }),
        [countries, states, cities]
    );

    useEffect(() => {
        
        fetchRetiler()
    }, [orderID])



    const fetchRetiler = async () => {
        

        try {



            const res = await AuthService.GetOrderDetail(orderID)
            
            // setTotalRecords(res?.data?.totalRecords)

            // const itemList = res?.data?.items ?? [];


            // const item = itemList.map((item: any) => ({

            //         orderID: item.id,
            //         orderDate: item.orderDate,
            //         companyName: item.companyName,
            //         totalQuantity: item.totalQuantity,
            //         expectedDeliveryDate: item.expectedDeliveryDate,
            //         retailerEmail: item.email,
            //         retailer:item.retailerName,
            //         comments: item.comments,
            //         shippingAddress: item.shippingAddress,
            //         orderDetails: item.orderDetails



            //     }))


            // setAttendanceData(item);
            // setTotalRecords(res?.data?.totalRecords || 0);


        }
        catch {

        }
        finally {
            setLoading(false)
        }
    }

    const { register, handleSubmit, control, watch, formState, setValue, reset } = useForm({
        defaultValues: getInitialValues(formConfig),
        mode: "onTouched"

    })


    // const selectedCountryId = watch("country");
    // const selectedStateId = watch("State");
    const selectedType = watch("type");
    // const selectedCityId = watch("City")
    const selectedCountryId = watch("countryId");
    const selectedStateId = watch("stateId");
    const selectedCityId = watch("cityId");

   


    
    



  


    const handleSave = (selectedAddress: any) => {


        setMapModalOpen(false);
    };


    const handleSelectLocation = (lat: number, lng: number, addr: string) => {

        setMapLocation({ lat, lng });
        setSelectedAddress(addr);

        // Update all form fields immediately
        setValue("address", addr);
        setValue("latitude", lat);
        setValue("longitude", lng);
    };
    const dynamicFormConfig = (() => {
        const config: any = { ...formConfig };

        if (selectedType === "Retailer") {

            const entries = Object.entries(config);


            const typeIndex = entries.findIndex(([key]) => key === "type");


            const distributorField: [string, any] = [
                "DistributorCode",
                {
                    defaultValue: "",
                    validations: { required: requiredMessage("Distributor Code") },
                    controlType: "input",
                    label: "Distributor Code",
                    isRequired: true,
                },
            ];

            // Insert DistributorCode after "type"
            entries.splice(typeIndex + 1, 0, distributorField);

            // Convert back to object
            return Object.fromEntries(entries);
        }

        return config;
    })();

    const handleDeleteConfirm = async (selectedRow: any) => {
        try {
            const res = await AuthService.DeleteRetailer(selectedRow);
            if (res?.status === 200 && res?.data === true) {
                toast.success(res?.message || "Deleted successfully");
                setDeleteModalOpen(false);
                fetchRetiler();


            }
            else {

                toast.error(res?.error || "Something went wrong");
            }



        }
        catch (error: any) {
            
            const backendMessage =
                error?.response?.data?.error ||
                error?.message ||
                "Something went wrong";

            toast.error(backendMessage);
        }

    };

    const onSubmitEdit = async (values: any) => {
        const payload = {
            companyName: values.companyName,
            name: values.name,
            designation: values.designation,
            mobileNumber: values.mobileNumber,
            emailId: values.emailId,
            address: values.address,
            // address: ,
            latitude: values.latitude,
            longitude: values.longitude,
            cityId: values.cityId,
            stateId: values.stateId,
            countryId: values.countryId,
            distributorId: 1,
            pincode: values.pincode,
            // gstNo: ,
            // panNo: ,
            // contactName: ,
            contactNo: values.contactNo,
            contactEmail: values.contactEmail,
            rejectedReason: ""

        };
        try {
            const res = await AuthService.EditRetailer(selectedRow.id, payload);

            if (res?.status === 200 && res?.message) {
                toast.success(res.message || "Warehouse updated successfully");
                fetchRetiler();
                setEditModalOpen(false);
            } else {

                toast.error(res?.error || "Failed to update warehouse");
            }
        }
        catch (error) {
            console.error("UPDATE ERROR:", error);

        }
    };

    const handleCopy = () => {
        if (!shareLink) return;

        navigator.clipboard.writeText(shareLink);
        setCopied(true);
        toast.success("Link Copied!");

        setTimeout(() => {
            setCopied(false); 
        }, 2000);
    };

    useEffect(() => {
        setPage(0);              
        // fetchRetiler(searchText, activeTab);
    }, [activeTab]);

    // const currentConfig = TAB_CONFIG[activeTab];
    return (
        <div className="5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">List Items</h2>
          <div className="flex items-center gap-3">
            <input
              type="text"
              placeholder="Search Warehouse..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="border px-3 py-2 rounded-md w-64 border-gray-300"
            />
  
            {/* <Button variant="contained" color="primary" onClick={handleOpenModal}>
              + Add Warehouse
            </Button> */}
          </div>
        </div>
        <div>
          {/* <Button variant="contained" color="primary" onClick={handleOpen}>
                      + Add drawer
                  </Button> */}
        </div>
  
        {totalRecords === 0 ? (
      <div className="flex flex-col items-center justify-center mt-20">
        <img
          src="/assets/media/wholesale_9725779.png" 
          alt="No Retailer added yet"
          className="w-40 h-40 mb-4"
        />
        <h3 className="text-lg font-semibold mb-2">No Warehouse added yet</h3>
        <p className="text-gray-500 mb-4">
          Add a Warehouse and kickstart operations
        </p>
        <button
          onClick={handleOpenModal}
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          Add Warehouse
        </button>
      </div>
    ) : (
  
        <Table
          columns={columns} data={attendanceData}
          progressPending={loading}
          paginationProps={{
            isPagination: true,
            totalCount: attendanceData.length,
            pageSelected: page,
            setPageSelected: setPage,
            rowsPerPageValue: rowsPerPage,
            setRowsPerPageValue: setRowsPerPage,
            loading,
          }}
  
        />
    )}
    
      </div>
    )

}

export default  OrderListItem
